const profilesPath =
  "https://leadguitar.s3.eu-north-1.amazonaws.com/teachers/profiles.json";
const lessonStructurePath =
  "https://leadguitar.s3.eu-north-1.amazonaws.com/homepage/lessonStructure.json";
const lessonNomineePath =
  "https://leadguitar.s3.eu-north-1.amazonaws.com/homepage/lessonNominee.json";

export const fetchTeachersData = async () => {
  try {
    const response = await fetch(
      `${profilesPath}?timestamp=${new Date().getTime()}`
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching teachers data", error);
  }
};

export const fetchLessonStructure = async () => {
  try {
    const response = await fetch(`${lessonStructurePath}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Lesson structure data", error);
  }
};

export const fetchLessonNominee = async () => {
  try {
    const response = await fetch(`${lessonNomineePath}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error while trying to fetch lesson nominee", error);
  }
};
